<template>
  <el-dialog
    title="选择会员"
    :visible.sync="visible"
    width="800px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.userName"
        placeholder="请输入会员姓名"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.userId"
            :label="row.userId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="会员姓名"
        :resizable="false"
        prop="userName"></el-table-column>
      <el-table-column
        label="手机号"
        :resizable="false"
        prop="mobilePhone"
        width="100"></el-table-column>
      <el-table-column
        label="昵称"
        :resizable="false"
        prop="nickname"
        width="100"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'StaffSelectModal',
  components: { },
  props: {
    callback: Function,
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      vendorId: null,
      agentId: null,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        isStaff: true,
        userName: ''
      },
      total: 0,
      current: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.total = 0
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.userId) {
        this.$message.error('请选择一个会员')
        return
      }
      this.upgrade()
    },
    upgrade() {
      this.loading = true
      this.$store.dispatch('agent/setagentinviter', {
        payload: {
          vendorId: this.vendorId,
          agentId: this.agentId,
          inviterUserId: this.current.userId
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('member/getmyusers', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.vendorId = row.vendorId
      this.agentId = row.agentId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
